import type { JSX } from 'react';

interface LineHistoryButtonProps {
  onClick: () => void;
  unreadCount?: number;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
}

export function LineHistoryButton({ onClick, unreadCount = 0, position = 'bottom-right' }: LineHistoryButtonProps): JSX.Element {
  return (
    <button
      className={`line-history-fab line-history-fab--${position}`}
      onClick={onClick}
      aria-label="LINE履歴を確認"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2C6.48 2 2 5.58 2 10c0 2.24 1.2 4.24 3.08 5.62-.1.88-.56 3.28-.58 3.38 0 .08.04.18.12.22.04.02.08.02.12.02.06 0 .12-.02.18-.06.86-.58 3.36-2.22 4.08-2.72.64.1 1.3.14 2 .14 5.52 0 10-3.58 10-8S17.52 2 12 2Z" fill="#06C755"/>
      </svg>
      {unreadCount > 0 && (
        <span className="line-history-fab__badge">{unreadCount > 9 ? '9+' : unreadCount}</span>
      )}
    </button>
  );
}
